import React, { Component } from 'react'
import autobind from 'autobind-decorator'
import DefaultMenuDetailForm from './DefaultMenuDetailForm'
import TextDetailForm from "./TextDetailForm"
import CategoryDetailForm from "./CategoryDetailForm"
import PageDetailForm from "./PageDetailForm"

export default function TypeDetailForm({ selectedType, onChange, onChangeFocus }) {

  function handleFocus() {
    onChangeFocus(true)
  }

  function handleBlur()  {
    onChangeFocus(false)
  }

  switch(selectedType.value) {
    case 'default':
      return <DefaultMenuDetailForm onChange={onChange} onFocus={handleFocus} onBlur={handleBlur} />
    case 'page':
      return <PageDetailForm onChange={onChange} onFocus={handleFocus} onBlur={handleBlur} />
    case 'category':
      return <CategoryDetailForm onChange={onChange} onFocus={handleFocus} onBlur={handleBlur} />
    case 'tag':
      return <TextDetailForm key="11" typeId={11} defalutValue="" placeholder="태그" onChange={onChange} onFocus={handleFocus} onBlur={handleBlur} />
    case 'url':
    default:
      return <TextDetailForm key="13" typeId={13} defaultValue="http://" placeholder="예) https://www.tistory.com" onChange={onChange} onFocus={handleFocus} onBlur={handleBlur} />
  }
}
